export const TitleBar = {
    title: 'Danh sách sản phẩm',
    addButtonText: 'Tạo mới',
};

export const Search = {
    searchText: 'Tìm kiếm theo từ khoá Mã sản phẩm, Tên sản phẩm',
};

export const TableColumns = [
    { text: 'Mã sản phẩm', icon: <></> },
    { text: 'Tên sản phẩm', icon: <></> },
    { text: 'Danh mục', icon: <></> },
    { text: "Nhóm sản phẩm", icon: <></>},
    { text: 'Kho số', icon: <></> },
    { text: 'Trạng thái', icon: <></> },
    { text: 'Tồn Kho', icon: <></> },
];

export const ProductCategoryGroupTableColumns = [
    { text: 'ID', icon: <></> },
    { text: 'Tên nhóm sản phẩm', icon: <></> },
    { text: 'Hành động', icon: <></> },
];

export const MaterialCategoryGroupTableColumns = [
    { text: 'ID', icon: <></> },
    { text: 'Tên nhóm vật tư', icon: <></> },
    { text: 'Hành động', icon: <></> },
];

export const HistoryTableColumns = [
    { text: 'Ngày tạo', icon: <></> },
    { text: 'Số lượng', icon: <></> },
    { text: 'Xuất/nhập kho', icon: <></> },
    { text: 'Đơn hàng', icon: <></> },
    { text: 'Người tạo', icon: <></> },
];


export const CreateProductTitleBar = {
    title: 'Thêm sản phẩm mới',
    cancelButton: 'Huỷ bỏ',
    addButton: 'Lưu Sản Phẩm',
};

export const DetailProductTitleBar = {
    cancelButton: 'Huỷ bỏ',
    duplicateButton: 'Nhân bản',
    addButton: 'Lưu Sản Phẩm',
    deleteButton: 'Xoá sản phẩm',
};

export const DeleteProductModal = {
    title: 'Xoá sản phẩm',
    context: 'Bạn có chắc chắn muốn xoá sản phẩm này không? Hành động này sẽ không được hoàn tác.',
};

export const ProductCustomerColumns = [
    { text: 'Tên khách hàng', icon: <></> },
    { text: "Giá bán", icon: <></>},
    { text: "", icon: <></>},
    // { text: 'Giá dịch vụ kèm theo', icon: <></> },
    // { text: 'Số lượng', icon: <></> },
    // { text: 'Tên dịch vụ', icon: <></> },
    // { text: 'Thêm dịch vụ', icon: <></> },
    // { text: '', icon: <></> },
];

export const ProductCategories = [
    "Thùng",
    "Cơ Khí Ô Tô",
    "Phuy",
]
